import Vue from 'vue';
import * as Lib from '@ext/index';
import moment from 'moment';
import { isString } from 'util';
import { Usuario } from '@/views/a-login/login-controlador';

export class ControladorDeRecuperacion extends Vue
{
    constructor()
    {
        super();
        this.UsuarioActual = new Usuario();
    }

    UsuarioActual: Usuario;
    public Modo: 'email' | 'codigo' | 'usuario' | 'password' | 'error' | 'ok' = 'usuario';
    ModificarModo( modo: 'email' | 'codigo' | 'usuario' | 'password' | 'error' | 'ok' ,params?: any )
    {
        this.Modo = modo;
        this.$emit( 'modo', params);
    }

    public async ComprobarUsuario( u: string, t: 'u' | 'e' ): Promise<'ok' | 'datos-incorrectos' | 'error'>
    {

        this.UsuarioActual.Iniciar();

        try
        {
            let request = new Lib.apiRequest( '/c' );

            if ( t === 'u' ) request.body.u = u;
            else if ( t === 'e' ) request.body.e = u;

            if ( await request.post() )
            {
                if ( request.data.status === 'ok' )
                {

                    this.UsuarioActual.Nombre = request.data.nombre;
                    this.UsuarioActual.Apellido = request.data.apellido;
                    this.UsuarioActual.Usuario = request.data.usuario;
                    this.UsuarioActual.Email = request.data.email;
                    if ( request.data.avatar )
                        this.UsuarioActual.Avatar = request.data.avatar;
                    this.UsuarioActual.Existe = true;
                    await this.Iniciar();
                    this.ModificarModo( 'email' );
                }
                return request.data.status;
            }

        } catch ( e )
        {
            Lib.Log( e );
        }
        return 'error';
    }



    public async Iniciar( tk: string | null = null ): Promise<'activo' | 'enviado' | 'comprobado' | 'completado' | 'expirado' | 'error' | 'sesion-expirada'>
    {

        try
        {
            let request = new Lib.apiRequest( '/i' );
            if ( tk )
                request.body.tk = tk;

            if ( await request.post() )
            {

                if ( request.data.status === 'ok' )
                {

                    this.UsuarioActual.Nombre = request.data.nombre;
                    this.UsuarioActual.Apellido = request.data.apellido;
                    this.UsuarioActual.Usuario = request.data.usuario;
                    this.UsuarioActual.Email = request.data.email;
                    if ( request.data.avatar )
                        this.UsuarioActual.Avatar = request.data.avatar;
                    this.UsuarioActual.Existe = true;

                    if ( request.data.substatus == 'enviado' && tk )
                        this.ModificarModo( 'codigo' );
                    if ( request.data.substatus != 'activo' )
                        return request.data.substatus;
                }

                if ( request.data.status == 'sesion-expirada')
                    this.ModificarModo( 'error', 'expirada' );
                else if ( request.data.status == 'no-enviado' )
                    this.ModificarModo( 'error', 'error' );

                return request.data.status;
            }

        } catch ( e )
        {
            Lib.Log( e );
        }
        return 'error';

    }


    public async Enviar( p: string, Ignorar: boolean = false ): Promise<'enviado' | 'datos-incorrectos' | 'error'>
    {

        if ( !Ignorar )
        {
            const sha1 = require( 'js-sha1' );
            if ( !p || sha1( p ) + this.UsuarioActual.Email.substring( this.UsuarioActual.Email.search( '@' ) ) != this.UsuarioActual.Email )
                return 'datos-incorrectos';
        }

        try
        {
            let request = new Lib.apiRequest( '/ia' );

            if ( await request.post() )
            {
                if ( request.data.status == 'enviado' && !Ignorar )
                    this.ModificarModo( 'codigo' );
                return request.data.status;
            }

        } catch ( e )
        {
            Lib.Log( e );
        }
        return 'error';

    }

    public async Comprobar( p: string ): Promise<'ok' | 'enviado' | 'comprobado' | 'completado' | 'expirado' | 'error' | 'sesion-expirada' | 'datos-incorrectos' | 'error'>
    {

        if ( !p || parseInt( p ).isNan() || p.length != 6 )
            return 'datos-incorrectos';

        try
        {
            let request = new Lib.apiRequest( '/iac' );

            const sha1 = require( 'js-sha1' );
            request.body.p = sha1( p ) + '95a02873d057b02d352cbc02868b8139192199b8';
            if ( await request.post() )
            {

                if ( request.data.substatus == 'ok' )
                    this.ModificarModo( 'password' );
                else
                    return request.data.substatus;

                return request.data.status;
            }

        } catch ( e )
        {
            Lib.Log( e );
        }
        return 'error';

    }

    public async Cambiar( p1: string, p2: string ): Promise<'ok' | 'datos-incorrectos' | 'error'>
    {

        if ( !p1 || !p2 || p1 != p2 )
            return 'datos-incorrectos';

        try
        {
            let request = new Lib.apiRequest( '/iacc' );

            const sha1 = require( 'js-sha1' );
            request.body.a = sha1( p1 ) + '95a02873d057b02d352cbc02868b8139192199b8';
            request.body.b = sha1( p2 ) + '95a02873d057b02d352cbc02868b8139192199b8';

            if ( await request.post() )
            {
                if ( request.data.status == 'ok' )
                    this.ModificarModo('ok')

                return request.data.status;
            }

        } catch ( e )
        {
            Lib.Log( e );
        }
        return 'error';

    }

}